<template>
  <footer>
    <div class="inner">
      <div class="fl">
        <img
          src="@/assets/images/blend-it.png"
          alt="Blend It"
        >
      </div>
      <div class="svg-footer fColorLine" />
      <div class="fr">© PULIP COMMUNICATIONS Co., Ltd</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {
  },
  data () {
    return {
    }
  }
}
</script>
